import React, { forwardRef } from 'react';
import { Input } from 'antd';
import classNames from 'classnames';
import type { SearchProps } from 'antd/lib/input';
import { Styled } from './styled';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SearchInputRef = any;

const { Search } = Input;

export type SearchInputProps = SearchProps;

export const SearchInput = forwardRef<SearchInputRef, SearchInputProps>(
  ({ enterButton, addonAfter, addonBefore, className, ...props }, ref) => (
    <Styled className={classNames('SearchInput', className)}>
      <Search
        ref={ref}
        className={classNames({
          '-noAddonAfter': !addonAfter,
          '-noEnterButton': !enterButton,
          '-addonBefore': addonBefore,
        })}
        enterButton={enterButton}
        addonAfter={addonAfter}
        addonBefore={addonBefore}
        key="search-input"
        type="search"
        inputMode="search"
        {...props}
      />
    </Styled>
  )
);
SearchInput.displayName = 'SearchInput';
